import { FetchError } from "ofetch"
import type { BootstrapRequest, BootstrapResponse } from "~/stores/general"

export default defineNuxtRouteMiddleware(async () => {
	const url = useRequestURL()
	const routeUrl = useRouteUrl()
	const generalApiUrl = useGeneralApiUrl()
	const userStore = useUserStore()
	const categoryStore = useCategoryStore()
	const companyStore = useCompanyStore()
	const metaStore = useMetaStore()
	const blockchainStore = useBlockchainStore()
	const currencyStore = useCurrencyStore()
	const query = {
		hostname: url.hostname
	} as BootstrapRequest
	if (userStore.token && !userStore.user) query.profile = true
	if (!metaStore.metas) query.metas = true
	if (!categoryStore.categories) query.categories = true
	if (!blockchainStore.blockchains) query.blockchains = true
	if (!currencyStore.currencies) query.currencies = true
	if (companyStore.companyId && !companyStore.company?.id) query.company_id = companyStore.companyId
	if (Object.keys(query).length > 1) {
		let data: BootstrapResponse | null = null
		try {
			data = await $fetch<BootstrapResponse>(generalApiUrl.Bootstrap.url(), {
				...useFetchConfig(),
				method: generalApiUrl.Bootstrap.method,
				query
			})
		} catch (e: any) {
			if (e instanceof FetchError && [401, 403].includes(e.response?.status || 0)) {
				navigateTo(routeUrl.HomeUrl())
			} else if (import.meta.server) {
				useErrorPage(e)
			}
		}
		if (data?.data) {
			if (data.data.profile) userStore.user = data.data.profile
			if (data.data.metas) metaStore.metas = data.data.metas
			if (data.data.categories) categoryStore.categories = data.data.categories
			if (data.data.blockchains) blockchainStore.blockchains = data.data.blockchains
			if (data.data.currencies) currencyStore.currencies = data.data.currencies
			if (data.data.company) {
				companyStore.setCompany(data.data.company.id, data.data.company)
			}
			if (data.data.payroll_domain_company) {
				companyStore.payrollDomainCompany = data.data.payroll_domain_company
			} else if (data.data.career_domain_company) {
				companyStore.careerDomainCompany = data.data.career_domain_company
			}
			if (!data.data.company && data.data.profile?.company_id && data.data.profile?.type == "company-user") {
				companyStore.setCompany(data.data.profile?.company_id || null, null)
			}
			metaStore.isViraEnable = data.data.is_vira_enable
		}
	}
})
